<template>
  <div class="yxtbiz-joinlib_selectloading text-center text-8c">
    <yxtf-svg
      v-if="loading"
      width="20px"
      height="20px"
      icon-class="loading"
      class="v-mid"
    />
    <label v-else :class="{'mt10 mb24': emptyText}">{{ emptyText || $t('pc_biz_lbl_nosearch'/** 暂无搜索内容 */) }}</label>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    loading: Boolean,
    emptyText: String
  }
};
</script>
